import { Space } from "antd";
import { useMemo } from "react";
import { ModsPanelCompProps } from "../ModsPanel";
import { findLayersOrLayerAssets, modTypes } from "@blings/blings-player";
import type { ICustomChangeMod } from "@blings/blings-player";
import { DynamicValueMod } from "../DynamicValueMod";
import { LayerSelector } from "../../LayerSelector";
import { LayerPropertyTreeSelect } from "./LayerPropertyTreeSelect";

export function CustomChangeForm(props: ModsPanelCompProps<ICustomChangeMod>) {
  const { change, json } = props;
  const primaryLayer = useMemo(() => {
    if (!json || !change.layerName) return undefined;
    const layers = findLayersOrLayerAssets({
      assetId: change.assetId,
      layerName: change.layerName,
      layerUid: change.layerUid,
      jsonVid: json,
    });
    return layers?.[0];
  }, [change.assetId, change.layerName, change.layerUid, json]);

  return (
    <Space direction={"vertical"} size={12} style={{ width: "100%" }}>
      <div>
        <LayerSelector
          isMulti={true}
          assetLayerPairs={props.assetLayerPairs}
          selectedAssetId={change.assetId}
          selectedLayerName={change.layerName}
          selectedLayerUid={change.layerUid}
          selectedAdditionals={change.additionals}
          onChange={props.onLayerChange}
          index={props.index}
          jsonVid={json}
        />
      </div>
      <div>
        <span style={{ color: "#6E7079", lineHeight: "22px" }}>Path</span>
        <LayerPropertyTreeSelect
          layer={primaryLayer}
          value={change.path || undefined}
          onChange={(path) => props.onChange(props.index, "path", path ?? "")}
        />
      </div>
      <DynamicValueMod
        change={props.change}
        onChange={props.onChange}
        index={props.index}
        modId={props.modId}
        modT={modTypes.custom}
      />
    </Space>
  );
}
